/* Shared helpers for employee self-service pages. */
import { useSession } from "../../app/session";
import { addDays, weekday } from "../../domain/dates";

/** Pay day used for the countdown (employees cannot read company settings; default from setup). */
export const PAY_DAY = 27;
/** Fridays and Saturdays are not working days in the self-service leave count (prototype). */
export const WEEKEND = [5, 6];
/** Documents the employee renews personally; the rest are handled by the employer. */
export const PERSONAL_DOCS = ["Passport", "National ID", "Driving licence", "Driving license"];

export const periodOf = (iso: string) => iso.slice(0, 7);
export function shiftPeriod(period: string, months: number): string {
  const [y, m] = period.split("-").map(Number);
  const d = new Date(Date.UTC(y, m - 1 + months, 1));
  return d.getUTCFullYear() + "-" + String(d.getUTCMonth() + 1).padStart(2, "0");
}

/** Linked employee id of the signed-in user (null for non-ESS users). */
export function useEmployeeId(): number | null {
  return useSession().user?.employeeId ?? null;
}

/** Working days between two dates (inclusive), excluding the ESS weekend. */
export function workingDays(from: string, to: string): number {
  if (!from || !to || to < from) return 0;
  let n = 0;
  for (let d = from; d <= to; d = addDays(d, 1)) if (!WEEKEND.includes(weekday(d))) n++;
  return n;
}

/** Next pay date on or after today. */
export function nextPayDate(today: string, payDay = PAY_DAY): string {
  const p = periodOf(today);
  const thisMonth = p + "-" + String(payDay).padStart(2, "0");
  return today <= thisMonth ? thisMonth : shiftPeriod(p, 1) + "-" + String(payDay).padStart(2, "0");
}
